<script setup>
import {ref, onMounted} from 'vue'
import {NumberFormat, useI18n} from "vue-i18n";
import {useRoute, useRouter} from "vue-router";
import {getConnectionById} from "@/services/api/connection.js";
import EntityForm from "@/components/common/Form.vue";
import BasePage from "@/components/Layouts/BasePage.vue";
import {ConnectionEntity} from "@/entities/ConnectionEntity.js";
import {populateFormFromEntity} from "@/utils/index.js";
import {formatNumber} from "@/utils/numberFormat.js";
import Text from "@/components/common/Text.vue";
import BaseTable from "@/components/tables/BaseTable.vue";

const router =  useRouter();
const { t, locale } = useI18n();
const loading = ref(false);
const loadingMounted = ref(false);
const route = useRoute();
const havePermission = ref(false);
const form = ref(null)
const totalItems = ref(0);
const currentPage = ref(1);
const itemsPerPage = ref(10);
const Connection = new ConnectionEntity();
const entity = ref(Connection);
const formData = ref(entity.value.fields);
const id = route.params.id;
const isFetching = ref(false);
const items = ref([]);
const actions = ref({ view: "view" });

function onView(item) {
    router.push("/products/view/" + item.id);
}

onMounted(async () => {
    try {

        if (!id) return;

        loadingMounted.value = false;
        const data = await getConnectionById({ id });
        if (data) {
            data.value = {
                ...data.data,
                max_download: formatNumber(data.data.max_download, locale, 0),
                max_upload: formatNumber(data.data.max_upload, locale, 0),
                nasName: data?.data?.nas?.name,
                poolV4: data.poolV4?.name,
                poolV6: data.poolV6?.name,
            };
        }

        items.value = data.value.products.map(item => ({
            id: item.product?.id || null,
            name: item.product?.name || null
        }));

        totalItems.value = {
            "totalItems": items.value.length,
            "totalPages": 1,
            "limit": 100,
            "page": 1,
        }

        formData.value = data.value;
    } catch (e) {
        console.error(e);
    } finally {
        loadingMounted.value = true;
    }
});

</script>

<template >
    <BasePage :loading-mounted="loadingMounted" :entity="entity">
        <template v-if="loadingMounted" #default>
            <EntityForm :entity="entity" v-model="formData" disabled="true" ref="form" />
            <Text tag="h5" class="mb-8 mt-5">{{ t('components.contracts.product.pageTitle')}}</Text>
            <BaseTable
                :fetchData="null"
                :entity="entity"
                :items="items"
                tableToUse="tableProducts"
                :loading="!loadingMounted"
                :totalItems="totalItems"
                :currentPage="currentPage"
                :actions="actions"
                @view="onView"
            >
            </BaseTable>
        </template>
    </BasePage>
</template>
